import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminPage from "../pages/admin/page";
import GalleryPage from "../pages/admin/GalleryPage";
import CareersPage from "../pages/careers/page";
import ArtistsPage from "../pages/artists/page";
import TestimonialsPage from "../pages/testimonials/page";
import LeaveAReviewPage from "../pages/leave-a-review/page";
import CustomPage from "../pages/custom/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/artists",
    element: <ArtistsPage />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsPage />,
  },
  {
    path: "/leave-a-review",
    element: <LeaveAReviewPage />,
  },
  // Legacy custom page path (backward compatible)
  {
    path: "/p/:slug",
    element: <CustomPage />,
  },
  // Clean custom page path (preferred)
  {
    path: "/:slug",
    element: <CustomPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;